<div class="content-loading">
    <mat-spinner color="primary" diameter="40"></mat-spinner>
</div>